<script>
import Flickity from 'flickity';
import fadeInUp from '../components/animations/FadeInUp.vue';
import linesUp from '../components/animations/LinesUp.vue';
import wordsUp from '../components/animations/WordsUp.vue';
import zoomIn from '../components/animations/ZoomIn.vue';
import magnetic from '../components/Magnetic.vue';

export default {
    components: {
        fadeInUp,
        linesUp,
        wordsUp,
        zoomIn,
        magnetic
    },

    data() {
        return {
            flickity: null
        };
    },

    mounted() {
        if (this.$refs.slider) {
            this.flickity = new Flickity(this.$refs.slider, {
                cellAlign: 'left',
                prevNextButtons: false,
                pageDots: false,
                selectedAttraction: 0.01,
                friction: 0.15
            });
        }

        ScrollTrigger.refresh();
        this.parallax();
    },

    methods: {
        parallax() {
            const parallax = gsap.timeline({
                scrollTrigger: {
                    trigger: this.$refs.container,
                    scrub: true
                }
            });

            parallax.fromTo(
                this.$refs.background,
                {
                    y: '-25%'
                },
                {
                    y: '25%',
                    ease: 'none'
                }
            );
        }
    }
};
</script>
